export default __webpack_public_path__ + "static/media/third.3c0843da.png";